import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeTravaux } from '../models/TypeTravaux';
import { Step2 } from '../../../../shared/models/component-messages/mapaIN/step2';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Component({
  selector: 'app-type-travaux',
  templateUrl: './type-travaux.component.html'
})
export class TypeTravauxComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeTravaux';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() marcheTravaux: TypeTravaux;

  public step2 = new Step2();

  radioButtonValue;
    radioButtonCtrlName;
    conceptionRealisation = RadioCheckBoxEnum.conceptionRealisation;
    execution = RadioCheckBoxEnum.execution;

  constructor() { }

  public ngOnInit() {

    if (this.marcheTravaux?.conceptionRealisation === RadioCheckBoxEnum.emptyValue){
      this.radioButtonValue = this.conceptionRealisation;
    } else if (this.marcheTravaux?.execution === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.execution;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_execution';
  }
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

